

var _installmentPlanTerms = require('./installmentPlanTerms');

var _installmentPlanTerms2 = _interopRequireDefault(_installmentPlanTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getItemName: _installmentPlanTerms2['default'].getItemName,
    getInstallmentPlanData: _installmentPlanTerms2['default'].getInstallmentPlanData
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/installmentplan-terms/index.js
// module id = ../node_modules/xo-page-components/src/installmentplan-terms/index.js
// module chunks = 0